import { createContext } from 'react';
import { ParametersEnum } from 'pages/dimensions/types';
import { TApi } from 'utils/api';

import { ESurfacesTypes } from 'pages/surface/types';

import {
  InputModes,
  InputTypes,
  LocalizedTextLanguages,
  ValidationTypes,
} from 'pages/common/consts/frontend-configuration';


export type TProjectConfigurationParameter = {
  key: string;
  value: string;
};

export interface TSurfaceItem {
  inputParameters: TInputParams;
  enums: {
    baseSurface?: {
      [key: string]: number;
    };
    typeInstallation?: {
      [key: string]: number;
    };
  };
}

export interface TExtendedSurfaceItem extends TSurfaceItem {
  name: ESurfacesTypes;
  label: string;
  materialLabel: string;
  parentCalculatorId?: string;
  materials: Array<{ name: string; label: string }>;
  typeInstallation?: {
    [key: string]: number;
  };
}

export interface Surface {
  [key: string]: TSurfaceItem;
}

export type TInputParams = Array<ParametersEnum>;

export type MeasurementServices = {
  name: string;
  priceMin: number;
  serviceURL: string;
  type: string;
};

export type TLocaleText = {
  language: LocalizedTextLanguages;
  text: string;
};

export type TPreset = {
  value: string | number | boolean;
  label: TLocaleText[];
};

export type TValidation = {
  type: ValidationTypes;
  params?: {
    [key: string]: number;
  } | null;
  errorText: TLocaleText[];
};

export type TOptions = {
  value: string;
  label: TLocaleText[];
  description: TLocaleText[];
};

export type TFrontendConfigurationItem = {
  name: string;
  type: InputTypes;
  inputMode: string;
  defaultValue?: string | number | boolean;
  label: TLocaleText[];
  presets?: TPreset[];
  hints?: TLocaleText[];
  validations?: TValidation[];
  options?: TOptions[];
};

export type TFilteredFrontendConfigurationItems = {
  [InputModes.FREE]?: TFrontendConfigurationItem[];
  [InputModes.RESTRICTED]?: TFrontendConfigurationItem[];
  [InputModes.CHECKBOX]?: TFrontendConfigurationItem[];
};

export interface TData {
  productId: string;
  displayedName: string;
  photo: string;
  mainPrice: number;
  additionalPrice: number;
  additionalAsMain?: boolean;
  mainUomRus: string;
  additionalUomRus: string;
  projectConfigurationParameters: Array<TProjectConfigurationParameter> | null;
  surfaces: {
    parentCalculatorId?: string;
    surface: Surface;
    complimentaryProducts: string[];
    id: string;
    services?: MeasurementServices[];
    frontendConfiguration: TFrontendConfigurationItem[] | null;
  };
  currentRoute: string;
  isSurfaceOne: boolean;
  env: {
    ORCHESTRATOR_HOST: string;
    BASKET_URL: string;
    API_KEY: string;
    ROBOTINT_CLIENT_ID: string;
    ROBOTINT_SECRET: string;
    ROBOTINT_LINK: string;
  };
  api: TApi;
  regionId: string;
  isSaveProjectEnable: boolean | null;
  isTintAvailable: boolean;
  collectionName: string | null;
  colorName: string | null;
  hex: string | null;
  barcode: string | null;
  weight: string | null;
  serviceId: string | null;
}

type TRouteContext = {
  context: string | null;
  setContext: React.Dispatch<React.SetStateAction<string>>;
};

export const DataContext = createContext<TData | null>(null);
export const RouteContext = createContext<TRouteContext>({
  context: null,
  setContext: () => {
    // empty initial function
  },
});
